import type { MeResponse } from '@exam-prep/contracts';

/** Mirrors the server's RBAC check for showing/hiding controls (the API enforces it regardless). */
export function hasPermission(
  me: MeResponse | null | undefined,
  permission: string,
  productId?: string,
): boolean {
  if (!me) return false;
  return me.permissions.some(
    (p) =>
      p.permission === permission &&
      (p.productId === null || (productId !== undefined && p.productId === productId)),
  );
}
